export const API_URL = process.env.REACT_APP_API_URL || ''
export const BASE_URL = process.env.REACT_APP_BASE_URL || ''
export const CLIENT_URL = process.env.REACT_APP_CLIENT_URL || ''
export const S3_URL = process.env.REACT_APP_S3_URL || ''
export const REST_API_URL = process.env.REACT_APP_REST_API_URL || ''
export const SHOW_EBOOK_FEATURE =
  process.env.REACT_APP_SHOW_EBOOK_FEATURE === 'true'
